'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stringify = exports.isStateless = exports.getComponentName = exports.getContextValue = undefined;

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getContextValue = exports.getContextValue = function getContextValue(context, name) {
  (0, _invariant2.default)(context.automata, 'No context received.');

  var channel = name || 'DEFAULT';
  var value = context.automata[channel];

  (0, _invariant2.default)(value, 'No value for channel: "%s".', channel);

  return value;
};

var getComponentName = exports.getComponentName = function getComponentName(Component) {
  return Component.displayName || Component.name || 'Component';
};

var isStateless = exports.isStateless = function isStateless(Component) {
  var _ref;

  return !((_ref = Component) != null ? (_ref = _ref.prototype) != null ? _ref.isReactComponent : _ref : _ref);
};

var stringify = exports.stringify = function stringify(state) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (typeof state === 'string') {
    return path.concat(state).join('.');
  }
  return Object.keys(state).reduce(function (prev, key) {
    return prev.concat(stringify(state[key], path.concat(key)));
  }, []);
};


//////////////////
// WEBPACK FOOTER
// ./~/react-automata/lib/utils.js
// module id = 377
// module chunks = 168707334958949